// extracted by mini-css-extract-plugin
export default {"button":"ServiceButton_button__F4sIl","active":"ServiceButton_active__CMVcl","icon":"ServiceButton_icon__V8hcU","label":"ServiceButton_label__lHcqy"};